import './css/styles.scss';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

document.addEventListener('DOMContentLoaded', () => {
	Fancybox.bind('[data-fancybox^="mosaik-"]', {});
});
